import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";

export const CcsCard = (props) => {
  const sc = props.slice.primary;

  const it = props.slice.items;

  let space = sc.spacing;

  if (space === "Both large") {
    space = "gutter";
  } else if (space === "Both small") {
    space = "gutter sm";
  } else if (space === "Top large") {
    space = "gutter bot";
  } else if (space === "Top small") {
    space = "gutter bot sm";
  } else if (space === "Bottom large") {
    space = "gutter top";
  } else {
    space = "gutter top sm";
  }

  let bg =
    sc.background === "gradient"
      ? "gradient-to-b from-grey-light to-white"
      : sc.background;

  return (
    <section className={"bg-" + bg + " " + space}>
      <div className="wrapper">
        <div className="flex flex-col md:flex-row flex-wrap justify-center gap-8 gap-y-24">
          {it.map((card, index) => {
            let str = card.categories.split(",");
            return (
              <Link
                key={index}
                to={card.link !== null ? card.link.url : ""}
                className="ccscard"
              >
                <span>
                  <span className="relative w-1/3 m-auto -mt-16 p-3 bg-white rounded-xl block border border-grey-md shadow-lg">
                    <GatsbyImage
                      image={getImage(card.partner_logo)}
                      alt=""
                      className="rounded-t-lg"
                    />
                  </span>
                  <span className="p-7 block">
                    {str.map((cat, index) => {
                      return (
                        <div
                          key={index}
                          className="text-purple text-lg border-b mb-3 pb-2 border-grey-md inline-block pr-4"
                        >
                          {cat}
                        </div>
                      );
                    })}
                    <p className="text-xl font-bold">{card.partner_title}</p>
                    <p className="mb-0 leading-snug">
                      <PrismicRichText field={card.content.richText} />
                    </p>
                    <div className="flex flex-wrap gap-2">
                      <div
                        className={
                          "pr-1 pl-2 pt-1 pb-1 rounded font-bold uppercase tracking-widest text-vs bg-grey-light " +
                          (card.program === "Program Enhancer"
                            ? "text-accessible-green"
                            : "text-teal-dark")
                        }
                      >
                        {card.program}
                      </div>
                    </div>
                  </span>
                </span>
                <span className="pb-7 pr-7 pl-7 block">
                  <span className="btn bg-purple">Learn more</span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
